import { For, Show } from "solid-js"
import { formatAvgDelay } from "../lib/format"
import { app } from "../store/app"
import { RouteBadge } from "./RouteBadge"
import { StatsPanel } from "./StatsPanel"

export function BrowseView() {
  return (
    <div class="panel-body">
      <input
        class="search"
        type="search"
        placeholder="search routes…"
        value={app.search()}
        autocomplete="off"
        spellcheck={false}
        onInput={(e) => app.setSearch(e.currentTarget.value)}
      />

      <div class="prefs-row">
        <button
          class={`btn tiny${app.uniqueColors() ? " primary" : ""}`}
          onClick={() => app.toggleUniqueColors()}
          title="Give shared GTFS colors (like all of Metro yellow) unique colors so routes are easier to tell apart"
        >
          {app.uniqueColors() ? "unique colors on" : "unique colors"}
        </button>
      </div>

      <StatsPanel />

      <Show when={app.enabledRouteList().length}>
        <div class="chip-row">
          <For each={app.enabledRouteList()}>
            {(routeId) => {
              const found = () => app.findRoute(routeId)
              return (
                <Show when={found()}>
                  {(item) => (
                    <button
                      class="chip"
                      onClick={() => {
                        app.setRouteEnabled(routeId, false)
                        if (app.selectedRouteId() === routeId) app.goBack()
                      }}
                    >
                      <RouteBadge route={item().route} /> ×
                    </button>
                  )}
                </Show>
              )
            }}
          </For>
        </div>
      </Show>

      <Show when={!app.filteredAgencies().length}>
        <div class="empty">no routes match</div>
      </Show>

      <For each={app.filteredAgencies()}>
        {(agency) => {
          const mode = () => app.agencyEnabledState()[agency.id] || "none"
          const agencyStat = () => app.agencyStats(agency.id)
          const collapsed = () => app.isAgencyCollapsed(agency.id)
          return (
            <section class={`agency${collapsed() ? " collapsed" : ""}`}>
              <div
                class="agency-head"
                role="button"
                tabIndex={0}
                onClick={() => app.toggleAgencyCollapsed(agency.id)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault()
                    app.toggleAgencyCollapsed(agency.id)
                  }
                }}
              >
                <div class="agency-head-main">
                  <div class="agency-title-row">
                    <span class={`collapse-chevron${collapsed() ? "" : " open"}`}>▸</span>
                    <strong>{agency.name}</strong>
                  </div>
                  <Show when={agencyStat()}>
                    {(s) => (
                      <span class="agency-stat muted">
                        {s().onTimePct == null ? "—" : `${s().onTimePct}% on time`}
                        {" · "}
                        {formatAvgDelay(s().avgDelaySec)}
                        {" · "}
                        {s().vehicles} live
                      </span>
                    )}
                  </Show>
                </div>
                <div class="agency-head-actions" onClick={(e) => e.stopPropagation()}>
                  <span class="muted">{agency.routes.length}</span>
                  <button
                    class={`btn tiny${mode() === "all" ? " primary" : ""}`}
                    onClick={() => app.toggleAgency(agency.id)}
                  >
                    {mode() === "all" ? "hide all" : "show all"}
                  </button>
                  <span
                    class={`toggle${mode() === "all" ? " on" : mode() === "some" ? " some" : ""}`}
                    title="Toggle all routes"
                    onClick={() => app.toggleAgency(agency.id)}
                  />
                </div>
              </div>

              <Show when={!collapsed()}>
                <div class="route-list">
                  <For each={agency.routes}>
                    {(route) => (
                      <button
                        class={`route-row${app.isRouteEnabled(route.id) ? " on" : ""}`}
                        onClick={() => app.openRoute(route.id)}
                      >
                        <RouteBadge route={route} />
                        <div class="route-meta">
                          <div class="route-name">{route.description}</div>
                        </div>
                        <span
                          class={`toggle${app.isRouteEnabled(route.id) ? " on" : ""}`}
                          title="Show on map"
                          onClick={(e) => {
                            e.stopPropagation()
                            app.toggleRoute(route.id)
                          }}
                        />
                      </button>
                    )}
                  </For>
                </div>
              </Show>
            </section>
          )
        }}
      </For>
    </div>
  )
}
